export default __webpack_public_path__ + "static/media/calcolor.62581e5f.webp";